import {
  getFirestore,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { app } from './config';
import { auth } from './firebase';
import type { UserDocument } from '../../../types/document';

const db = getFirestore(app);

export async function saveDocumentToFirestore(
  fileName: string,
  fileURL: string,
  fileType: string,
  fileSize: number
): Promise<void> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    const documentData = {
      userID: auth.currentUser.uid,
      fileName,
      fileURL,
      fileType,
      fileSize,
      uploadDate: serverTimestamp()
    };

    await addDoc(collection(db, 'documents'), documentData);
  } catch (error) {
    console.error('Error saving document to Firestore:', error);
    throw new Error('Failed to save document metadata');
  }
}

export async function getUserDocuments(): Promise<UserDocument[]> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    const q = query(
      collection(db, 'documents'),
      where('userID', '==', auth.currentUser.uid),
      orderBy('uploadDate', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(
      (doc) =>
        ({
          id: doc.id,
          ...doc.data(),
          uploadDate:
            doc.data().uploadDate?.toDate?.().toISOString() ||
            new Date().toISOString()
        } as UserDocument)
    );
  } catch (error) {
    console.error('Error fetching documents:', error);
    throw new Error('Failed to fetch documents');
  }
}

export async function deleteDocument(docId: string): Promise<void> {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  try {
    await deleteDoc(doc(db, 'documents', docId));
  } catch (error) {
    console.error('Error deleting document:', error);
    throw new Error('Failed to delete document');
  }
}